import { useState } from 'react';
import { useTranslation } from 'hooks/useTranslation';
import BeforeAfterPhotos from './BeforeAfterPhotos';
import BeforeAfterPhotosSnap from './BeforeAfterPhotosSnap';
import type { APIBeforeAfterPhoto } from 'types/BeforeAfterPhotos';

type Props = {
  slug: string;
  type: string;
  initialPhotos: APIBeforeAfterPhoto[];
  totalCount?: string | number;
  showViewPhotos?: boolean;
  isSnap?: boolean;
  limit?: number;
  allPhotos?: boolean;
  loadMorePhotos?: boolean;
};

const BeforeAfterPhotosContainer = ({
  slug,
  type,
  initialPhotos,
  totalCount = 0,
  showViewPhotos = true,
  isSnap = false,
  limit = 500,
  allPhotos = true,
  loadMorePhotos = true,
}: Props): JSX.Element | null => {
  const { locale } = useTranslation();
  const [sliderPhotos] = useState<APIBeforeAfterPhoto[]>(initialPhotos || []);

  const getPhotos = async (
    offset?: number,
    limit?: number,
    all?: boolean,
  ): Promise<Record<string, { baphotos: APIBeforeAfterPhoto[] }>> => {
    const headers = new Headers({
      'Content-Type': 'application/json',
    });

    const result = await fetch(
      `/api/media?slug=${slug}&recordType=${type}&locale=${locale}${
        offset ? `&offset=${offset}` : ''
      }${limit ? `&limit=${limit}` : ''}${all ? `&all=${all}` : ''}`,
      {
        headers,
      },
    );

    return await result.json();
  };

  if (!initialPhotos.length) {
    return null;
  }

  return isSnap ? (
    <BeforeAfterPhotosSnap
      beforeAfterPhotos={sliderPhotos}
      slug={slug}
      type={type}
      totalCount={totalCount}
      showViewPhotos={showViewPhotos}
      limit={limit}
      allPhotos={allPhotos}
      loadMorePhotos={loadMorePhotos}
    />
  ) : (
    <BeforeAfterPhotos
      beforeAfterPhotos={sliderPhotos}
      getPhotos={getPhotos}
      slug={slug}
      type={type}
      totalCount={totalCount}
    />
  );
};

export default BeforeAfterPhotosContainer;
